import Reports from "../pages/reports/Reports";

function ReportsRoutes () {
    return [
        {
            path: '/reports',
            element: <Reports />
        }
    ];
}

export default ReportsRoutes;